// extracted by mini-css-extract-plugin
export default {"component":"SearchInput_component__9cTci","wrapper":"SearchInput_wrapper__PoyqH","input":"SearchInput_input__oXb+b","icon":"SearchInput_icon__2xix-"};